import React, { useRef } from 'react'
import IconButton from '@material-ui/core/IconButton'
import ViewComfyIcon from '@material-ui/icons/ViewComfy'
import { TranslationDictionary, useDisclosure } from '@plandi/common'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import clsx from 'clsx'

import { useMenuServiceButtonStyles } from './menu-service-button.styles'
// import { getServiceURL } from './menu-service-button.constants'
import { SERVICES_URL } from './menu-service-button.constants'

type MenuServiceButtonProps = {
  translate?: TranslationDictionary['data']
  locale: string
}

export const MenuServiceButton: React.FC<MenuServiceButtonProps> = ({
  translate,
  locale
}) => {
  const classes = useMenuServiceButtonStyles()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const menuRef = useRef()
  // const url = getServiceURL(locale)
  const url = SERVICES_URL

  const services = [
    {
      url: locale === 'ru' ? `${url.main}/ru` : url.main,
      title: translate?.['main-page'],
      active: true
    },
    {
      url: locale === 'ru' ? `${url.blog}/ru/articles` : `${url.blog}/articles`,
      title: translate?.blog
    },
    {
      url: `https://${
        process.env.NEXT_PUBLIC_NODE_ENV === 'stage' ? 'stage-office' : 'office'
      }.plandi.io${locale === 'ru' ? '/ru' : ''}`,
      title: translate?.notifications['short-office']
    },
    {
      url: 'ru' ? `${url.job}/ru/applicants` : `${url.job}/applicants`,
      title: 'Фриланс и Работа'
    },
    {
      url: locale === 'ru' ? `${url.shop}/ru/projects` : `${url.shop}/projects`,
      title: translate?.market.title
    }
  ]

  return (
    <>
      <IconButton
        className={classes.button}
        color="inherit"
        innerRef={menuRef}
        onClick={onOpen}
      >
        <ViewComfyIcon />
      </IconButton>
      <Menu
        anchorEl={menuRef.current}
        open={isOpen}
        onClose={onClose}
        classes={{ list: classes.menu }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        {services.map((service) => {
          return (
            <MenuItem
              key={service.title}
              button
              href={service.url}
              className={clsx({
                [classes.activeLink]: service.active
              })}
              component="a"
              dense
            >
              {service.title}
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}
